var compile_template = function ($tpl) {
    var fns = {};
    var $eval = $tpl.find("[data-eval]").addBack();

    $eval.each(function (i, e) {
        var $e = $(e);
        var fnbody = $e.attr("data-eval");
        var fn = new Function("data", fnbody);
        fns[fnbody] = fn;
    });

    var result = function (data, $container) {
        var $t = $tpl.clone();
        if ($container) $container.append($t);

        $t.find("[data-eval]").addBack().each(function () {
            var $e = $(this);
            var fnbody = $e.attr("data-eval");
            fns[fnbody].call($e, data);
        });

        return $t;
    }

    result.every = function (datasource, $container) {
        for (var i = 0; i < datasource.length; i++) {
            result(datasource[i], $container);
        }
    }

    return result;
},
    ConsoleError = function (e) {
        setTimeout(function () { throw e; }, 0);
    };

// $fragment - fragment to complie
// attreval - attribute to look for evaluate
// args - optional list of arguments as string for compiled function example "data1, data2"
var compile_fragment = function ($fragment) {
    var $eval = $fragment.find("[data-eval]");

    // compile all eval
    var evalCompiled = [];
    {

        $eval.each(function (i, e) {
            var $e = $(e);
            var fnbody = $e.attr("data-eval");
            var fn = new Function("data", fnbody);
            evalCompiled.push(fn.bind($e));
        });
    }

    return function (data) {
        for (var i = 0; i < evalCompiled.length; i++)
            try {
                evalCompiled[i](data);
            }
            catch (e) {
                ConsoleError(e);
            }
    };
}
var templates = {}

$(function () {
    $("[data-template]").each(function () {
        var $this = $(this);
        var tpl = compile_template($this.detach().css("display", ""));
        templates[$this.attr("data-template")] = tpl;
    });


    $("[data-init]").each(function () {
        var $this = $(this);
        var fnbody = $this.attr("data-init");
        try {
            var fn = new Function(fnbody);
            fn.apply($this);
        }
        catch (e) {
            console.log(fnbody);
            ConsoleError(e);
        }
    });
});

Math.log10 = Math.log10 || function (x) {
    return Math.log(x) * Math.LOG10E;
};
//$(window).scroll(function () {
//    $(".table-scroll:not(.scroll-y)").each(function () {
//        var table = $(this).children('table'), tableb = table[0].getBoundingClientRect(),
//            tr = table.find('tr.head th'), trb = tr[0].getBoundingClientRect(),
//            tb = table.find('tr.rowSpan th'), tbb = tb[0].getBoundingClientRect(),
//            td = table.find('tr.filters td'), tdb = td[0].getBoundingClientRect(),
//            t = tableb.top;
//        z = tableb.height - (trb.height + tbb.height + tdb.height);
//        if ($('nav.f-tabs--multirow').hasClass('is-stuck')) {
//            var dy = Math.max(0, Math.min(z + 64, -t + 64)) + "px";
//        }
//        else {
//            var dy = Math.max(0, Math.min(z, -t)) + "px";
//        }
//        var h = table.find("tr.head th");
//        var d = table.find("tr.rowSpan th");
//        var b = table.find("tr.filters td");
//        for (var i = 0; i < b.length; i++)
//            b[i].style.top = dy;
//        for (var i = 0; i < h.length; i++)
//            h[i].style.top = dy;
//        for (var i = 0; i < d.length; i++)
//            d[i].style.top = dy;
//    })
//});

$.fn.textPercent = function (value) {
    return this.text(value.formatPercent()).addClass(value >= 0 ? 'text-positive' : 'text-negative');
};

$.fn.textUsd = function (value) {
    return this.text(value.toUsd()).addClass(value >= 0 ? 'text-positive' : 'text-negative');
};

$.fn.plainTextPercent = function (value) {
    return this.text(value.formatPercent());
};

$.fn.plainTextUsd = function (value) {
    return this.text(value.toUsd());
};

$.fn.plainTextUsdNoCent = function (value) {
    return this.text(value.toUsdNoCent());
};

Math.sign = Math.sign || function (x) {
    x = +x;
    if (x === 0 || isNaN(x)) {
        return x;
    }
    return x > 0 ? 1 : -1;
}